import { z } from 'zod';

import { SCREAMING_SNAKE_CASE_RE } from '../_shared/codes';

export const CardCategoryIdSchema = z.guid().brand<'CardCategoryId'>();

export type CardCategoryId = z.infer<typeof CardCategoryIdSchema>;

export const CardCategoryCodeSchema = z
  .string()
  .max(50)
  .regex(SCREAMING_SNAKE_CASE_RE, 'Code must be SCREAMING_SNAKE_CASE.')
  .brand<'CardCategoryCode'>();

export type CardCategoryCode = z.infer<typeof CardCategoryCodeSchema>;

export const CardCategorySchema = z.object({
  id: CardCategoryIdSchema,
  code: CardCategoryCodeSchema,
  label: z.string().max(100),
});

export type CardCategory = z.infer<typeof CardCategorySchema>;

export const CardCategorySnapshotSchema = z.object({
  id: CardCategoryIdSchema,
  code: CardCategoryCodeSchema,
  label: z.string().max(100),
});

export type CardCategorySnapshot = z.infer<typeof CardCategorySnapshotSchema>;

export const CreateCardCategoryInputSchema = z.object({
  code: CardCategoryCodeSchema,
  label: z.string().trim().min(1).max(100),
});

export type CreateCardCategoryInput = z.infer<typeof CreateCardCategoryInputSchema>;

export const UpdateCardCategoryInputSchema = z.object({
  label: z.string().trim().min(1).max(100).optional(),
});

export type UpdateCardCategoryInput = z.infer<typeof UpdateCardCategoryInputSchema>;
